module.exports = __webpack_public_path__ + "static/media/virtual.b3b6c7b4.png";